<template>
  <a-modal v-model:visible="visible" @cancel="closeModal" :footer="false">
    <template #title> {{ title }}</template>
    <h4 style="margin-top: 0">复制分享链接</h4>
    <a-typography-paragraph copyable>{{ link }}</a-typography-paragraph>
    <h4>手机扫码查看</h4>
    <img :src="codeImg" alt="" />
  </a-modal>
</template>

<script setup lang="ts">
import { withDefaults, defineProps, ref, defineExpose } from "vue";
import QRCode from "qrcode";
import { Message } from "@arco-design/web-vue";

/*
 * 定义组件属性类型
 * */
interface Props {
  // 分享连接
  link: string;
  // 弹窗标题
  title: string;
}

const codeImg = ref();

/*
 * 给组件指定初始值
 * */
const props = withDefaults(defineProps<Props>(), {
  link: () => "https://www.laoyujianli.com/share/yupi",
  title: () => "分享",
});

// 二维码生成
QRCode.toDataURL(props.link)
  .then((url: string) => {
    codeImg.value = url;
  })
  .catch((error: any) => {
    console.log(error);
    Message.error("生成二维码失败，" + error.message);
  });

const visible = ref(false);

const closeModal = () => {
  visible.value = false;
};

/*
 * 打开弹窗
 * */
const openModal = () => {
  visible.value = true;
};

defineExpose({
  openModal,
});
</script>

<style scoped></style>
